export default "__VITE_ASSET__79b427a0__"